export default {
    roleReadAllBegin(state) {
        state.loading = true;
    },
  
    roleReadAllSuccess(state, data) {
        state.loading = false;
        state.data = data.list !== undefined ? data.list.map(role => {
            role.permissions = role.permissions.map(permission => permission.id);
            return role;
            }) : [];

        state.totalRecords = data.total !== undefined ? data.total : 0;
    },

    roleReadAllErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    permissionReadAllSuccess(state, data) {
        state.permissions = data.list !== undefined ? data.list : [];
    },

    roleAddBegin(state) {
        state.loading = true;
    },

    roleAddSuccess(state) {
        state.loading = false;
    },

    roleAddErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    roleUpdateBegin(state) {
        state.loading = true;
    },

    roleUpdateSuccess(state, data) {
        state.loading = false;
        state.data = state.data.map(role => {
            if (role.id === data.id) {
                role = data;
            }
            return role;
        });
    },

    roleUpdateErr(state, err) {
        state.loading = false;
        state.error = err;
    },
};